// @flow 
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import {ClearOutlined} from "@mui/icons-material";

type Props = {};

const GridMultiColumnSearch = (props: Props) => {
	const {t, customSearch, setCustomSearch, refreshGrid} = props
	const clearSearch = async () => {
		await setCustomSearch('')
	}
	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down('sm'))
	return (
		<Box display={'flex'} flexWrap={'wrap'}>
			<Box display={'flex'} alignItems={'center'} mr={1} pb={1}>
				<TextField
					sx={{minWidth: '300px'}}
					value={customSearch}
					name={'customSearch'}
					onChange={(evt) => {
						setCustomSearch(evt.target.value)
					}}
					label={t("General Search")}
					size={'small'}
					slotProps={{
						htmlInput: {
							maxLength: 250
						},
					}}
					variant="standard"
				/>
			</Box>
			<Box display={'flex'} alignItems={'center'} pb={1} flexWrap={'wrap'} gap={1} direction={'row'} width={downSM ? '100%' : 'auto'}>
				<Button
					size={'small'}
					color={'success'}
					startIcon={<SearchIcon/>}
					onClick={() => refreshGrid()}
					variant={'contained'}
					fullWidth={downSM}
				>
					{t('Search')}
				</Button>
				<Button
					startIcon={<ClearOutlined/>}
					size={'small'}
					color={'error'}
					variant={'outlined'}
					fullWidth={downSM}
					onClick={() => {
						clearSearch().then(res => refreshGrid())
					}}
				>
					{t('Clear')}
				</Button>
			</Box>
		</Box>
	);
};

export default GridMultiColumnSearch